<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered off-board">
        <thead>
        <tr>
          <th>Name</th>
          <th>Off Boarding Type</th>
          <th>Details Reason</th>
          <th>Joining Date</th>
          <th>Application Date</th>
          <th>Last Working Date</th>
          <th>Attachment</th>
          <th>Status</th>
          <th>Recommendation</th>
          <th>Clearance & Approvals</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.contact_name }}</td>
          <td>{{ item.off_boarding_type }}</td>
          <td>{{ item.details_reason }}</td>
          <td>{{ item.formatted_employment_date_of_joining }}</td>
          <td>{{ item.created_at_formatted }}</td>
          <td>{{ item.last_working_date_formatted }}</td>
          <td>
            <button v-if="item.attachments.length > 0" class="btn btn-primary btn-sm"
                    style="cursor: pointer"
                    @click="viewAttachments(item.attachments)"
            >
              <i class="fas fa-eye"></i>
              View
            </button>
            <span v-else class="badge btn-danger">
               No attachments
            </span>
          </td>
          <td>{{ item.status }}</td>
          <td>
            <button v-if="['pending', 'pending-approval'].includes(item.status)" class="btn btn-primary btn-sm"
                    @click="openEditModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
            <span class="text-capitalize">{{ item.recommendation_type }}</span>
          </td>
          <td>
            <button class="btn btn-primary btn-sm"
                    @click="openClearanceModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
           </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>

    <ViewAttachment
        ref="viewAttachmentRef"
        :attachments="modalAttachments"
    />

    <EmployeeOffBoardingRecommendationModal
        v-if="store.state.isModalOpenTwo"
        :formData="formData"
        @getOffBoardingList="getOffBoardingList"
    />

    <EmployeeOffBoardingClearanceStatusModal
        v-if="store.state.isModalOpenFour"
        :clearanceData="clearanceData"
    />
  </div>
</template>

<script setup>
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import EmployeeOffBoardingRecommendationModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingRecommendationModal.vue';
import EmployeeOffBoardingClearanceStatusModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingClearanceStatusModal.vue';
import {ref} from "vue";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'

const props  = defineProps({
  tableItems     : Object,
  formData:{
    type:Object,
    default:{}
  },
  getOffBoardingList:{
    type:Function
  },
});
const store = useStore();
const route = useRoute();
const modalAttachments = ref([]);
const clearanceData = ref([]);
const viewAttachmentRef = ref();
const {
  fetchSingleEmployeeOffBoardingRecommended
} = handleHrPayroll()

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

const formData = ref({
  contact_profile: [],
  employee_off_boarding_id:null,
  recommendation_type:null,
  last_working_date:null,
})

const openEditModal = (item) => {
  formData.value.employee_off_boarding_id = item.id
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleEmployeeOffBoardingRecommended(item.id, query).then(res => {
    if (!res.status){
      return
    }
    let data = res.data;
    formData.value.recommendation_type = data.recommendation_type;
    formData.value.last_working_date = data.last_working_date;
    formData.value.contact_profile = data.employee_offboarding_logs;
  });

  store.state.isModalOpenTwo = true
}

const openClearanceModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleEmployeeOffBoardingRecommended(item.id, query).then(res => {
    if (!res.status){
      return
    }
    clearanceData.value = res.data;
    store.state.isModalOpenFour = true
  });
}

</script>

